import Chevron from '../Chevron/Chevron'
import KYCAccountBadge from '../KYCAccountBadge/KYCAccountBadge'
import KYCBenefitRow from '../KYCBenefitRow/KYCBenefitRow'
import KYCLevelCover from '../KYCLevelCover/KYCLevelCover'
import UpgradeIcon from '../UpgradeIcon/UpgradeIcon'
import { KYC_LEVELS } from '@jagad/constants'
import { Container, Header, HeaderText, Body, BodyTitle, CoverContainer, Footer, FooterContent, BenefitsContainer } from './KYCLevelCard.styles'

export type KYCLevelCardProps = {
    boldHeader?: boolean
    level: number
    onUpgrade?: () => void
    disabled?: boolean
    benefits: {
        title: string
        value: string | boolean | number
        unit?: string
        unitPosition?: 'left' | 'right'
        isCurrency?: boolean
    }[]
    // translated strings
    accountLevelLabel: string
    benefitsLabel: string
    upgradeButtonLabel: string
    // KYCLevelCover translated strings
    coverBenefitsText: string
    coverComingSoonText: string
    coverStarsAltText: string
}

const KYCLevelCard = ({
    level,
    boldHeader = true,
    onUpgrade,
    disabled,
    benefits,
    accountLevelLabel,
    benefitsLabel,
    upgradeButtonLabel,
    coverBenefitsText,
    coverComingSoonText,
    coverStarsAltText,
}: KYCLevelCardProps) => {
    return (
        <Container>
            <Header $backgroundColor={KYC_LEVELS[level].secondaryColor}>
                <HeaderText>{accountLevelLabel}</HeaderText>
                <KYCAccountBadge
                    level={level}
                    bold={boldHeader}
                />
            </Header>

            <Body>
                <BodyTitle>
                    {benefitsLabel}
                </BodyTitle>
                <BenefitsContainer>
                    {benefits.map((benefit, index) => (
                        <KYCBenefitRow
                            key={index}
                            keyName={benefit.title}
                            value={benefit.value}
                            isCurrency={benefit.isCurrency}
                            unit={benefit.unit}
                            unitPosition={benefit.unitPosition}
                        />
                    ))}
                </BenefitsContainer>
            </Body>
            <CoverContainer>
                {disabled ? (
                    <KYCLevelCover
                        benefitsText={coverBenefitsText}
                        comingSoonText={coverComingSoonText}
                        starsAltText={coverStarsAltText}
                    />
                ) : null}
            </CoverContainer>
            {onUpgrade && <Footer onClick={onUpgrade}>
                <FooterContent>
                    <UpgradeIcon />
                    <span>{upgradeButtonLabel}</span>
                </FooterContent>
                <Chevron direction="right" strokeWidth={1} />
            </Footer>}
        </Container>
    )
}

export default KYCLevelCard
